import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import { dv360TargetingSelector } from '../../../../../../../../modules/selectors/dv360Constants'
import { targetingTypes } from '../../../../../LineItemDv360Create/fields'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const ManuallyEnteredSitesAndAppsPreview = () => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const targeting = useSelector(dv360TargetingSelector)

  const urls = useMemo(() => {
    return targeting
      .filter(option => option.type === targetingTypes.TARGETING_TYPE_URL && !option.negative)
      .map(option => option.url)
  }, [targeting])

  const excludedUrls = useMemo(() => {
    return targeting
      .filter(option => option.type === targetingTypes.TARGETING_TYPE_URL && option.negative)
      .map(option => option.url)
  }, [targeting])

  const apps = useMemo(() => {
    return targeting
      .filter(option => option.type === targetingTypes.TARGETING_TYPE_APP && !option.negative)
      .map(option => option.app_id)
  }, [targeting])

  const excludedApps = useMemo(() => {
    return targeting
      .filter(option => option.type === targetingTypes.TARGETING_TYPE_APP && option.negative)
      .map(option => option.app_id)
  }, [targeting])

  return (
    <>
      {(urls.length > 0 || excludedUrls.length > 0) && (
        <section className={classnames(drawerFormClasses.section, classes.urlsSection)}>
          {urls.length > 0 && (
            <>
              <h3 className={drawerFormClasses.sectionTitle}>{t('Urls')}</h3>
              {urls.map(url => (
                <p>{url}</p>
              ))}
            </>
          )}

          {excludedUrls.length > 0 && (
            <>
              <h3 className={classnames(drawerFormClasses.sectionTitle, classes.excludeUrlsTitle)}>
                {t('Excluded urls')}
              </h3>
              {excludedUrls.map(url => (
                <p>{url}</p>
              ))}
            </>
          )}
        </section>
      )}

      {(apps.length > 0 || excludedApps.length > 0) && (
        <section className={classnames(drawerFormClasses.section, classes.urlsSection)}>
          {apps.length > 0 && (
            <>
              <h3 className={drawerFormClasses.sectionTitle}>{t('Apps')}</h3>
              {apps.map(app => (
                <p>{app}</p>
              ))}
            </>
          )}

          {excludedApps.length > 0 && (
            <>
              <h3 className={classnames(drawerFormClasses.sectionTitle, classes.excludeAppsTitle)}>
                {t('Excluded apps')}
              </h3>
              {excludedApps.map(app => (
                <p>{app}</p>
              ))}
            </>
          )}
        </section>
      )}
    </>
  )
}

export default ManuallyEnteredSitesAndAppsPreview
